import { Stack, Typography } from "@mui/material";
import TextWithIcon from "../TextWithIcon";
import { toLocalDate } from "../../utils/formatData";
import { FiCalendar, FiLink, FiLock } from "react-icons/fi";
import { useTheme } from "@mui/material";

const ClientInfo = ({ client }) => {
  const theme = useTheme();
  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography
          variant="h4"
          gutterBottom
          color={theme.palette.text.primary}
        >
          {client?.name} {client?.surname}
        </Typography>
      </Stack>
      <TextWithIcon Icon={FiLink} text={client?.redirect_uris?.join(", ")} />
      <TextWithIcon Icon={FiLock} text={client?.allowed_grants?.join(", ")} />
      <TextWithIcon Icon={FiCalendar} text={toLocalDate(client?.created_at)} />
    </Stack>
  );
};

export default ClientInfo;
